import React from "react";
import InfoTip from "@/components/onboarding/InfoTip";

// Shown when VAT registered is "yes" or not answered yet.
export const VatLearnMore = ({ vat, testid = "vat-learn-more" }) => {
  if (vat === "no") return null;
  return (
    <p className="text-sm text-black/75" data-testid={testid}>
      VAT registered?{" "}
      <InfoTip label="Learn more" testid={`${testid}-tip`}>
        As you're VAT registered, enter every amount including VAT, as it actually leaves or lands in
        your bank. That goes for all your costs and your sales. And don't forget your quarterly VAT
        payment to HMRC: add it as a regular cost. An estimate is fine for now; you can correct it later.
      </InfoTip>
    </p>
  );
};

export default VatLearnMore;
